import { render, staticRenderFns } from "./ProductionControl.vue?vue&type=template&id=08e878c6&"
import script from "./ProductionControl.vue?vue&type=script&lang=js&"
export * from "./ProductionControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports